module.exports = __webpack_public_path__ + "static/media/data_categories_icon.61f7449d.svg";